/**
 * Client-side flag gate for the SDL consent surfaces (consent-surface spec
 * qlearn-sdl-consent-surface-spec-v1.md, acceptance criterion 2): while
 * REACT_APP_SDL_CONSENT_ENABLED is absent — the deployed default — every SDL
 * consent surface renders NOTHING (byte-identical dark posture, the
 * GL/Audio-Mode fail-closed discipline). The server enforces its own gate
 * (uniform 404 while qlearn.session-learning.enabled=false) and stays
 * authoritative; this flag is UX-only.
 *
 * Fail-closed: only the exact string "true" turns the surface on; absent and
 * any other value resolve to off.
 */
export const sdlConsentAvailable = () =>
  process.env.REACT_APP_SDL_CONSENT_ENABLED === "true";
